/* lp-cart.js — one door into Shopify's cart for every Leatherpress element (the collection shelf, the
   product page). It makes the SAME request and dispatches the SAME CartLinesUpdateEvent that
   Horizon's own product form does, so the cart drawer auto-opens, the header count updates and the
   cart-items sections are re-rendered from the response. The import-mapped modules
   (@shopify/events, @theme/utilities) are loaded on first use; a browser with no module graph adds
   the plain way and goes to the cart page. Tests replace it through window.LPCart. 17 Sep 2026. */
/* 23 Sep 2026: this file is now loaded as type="module" (see lp-product.liquid and lp-collection-shelf.liquid).
   The first version loaded the two Shopify modules on demand with import() from a classic script; on the
   live storefront that import rejected every time — the click fell through to the plain fallback below and
   the visitor was bounced to the cart page instead of seeing the drawer open (found in the pre-launch
   purchase check). Static imports through the theme's import map are exactly what Horizon's own
   product-form.js does, and they resolve. */
import * as Ev from '@shopify/events';
import * as U from '@theme/utilities';

(function () {
  'use strict';
  if (window.lpCartAdd) return;
  window.lpCartAdd = function (host, variantId, qty, productId) {
    if (window.LPCart && typeof window.LPCart.add === 'function') return Promise.resolve(window.LPCart.add(variantId, qty, productId));
    var routes = (window.Theme && window.Theme.routes) || { cart_add_url: '/cart/add.js', cart_url: '/cart' };
    var fd = new FormData(); fd.append('id', String(variantId)); fd.append('quantity', String(qty || 1));
    return Promise.resolve().then(function () {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
      if (ids.length) fd.append('sections', ids.join(','));
      var deferred = Ev.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new Ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity: qty || 1 }], promise: deferred.promise }));
      var cfg = U.fetchConfig('javascript', { body: fd });
      var headers = Object.assign({}, cfg.headers, { Accept: 'text/html' });
      return fetch(routes.cart_add_url, Object.assign({}, cfg, { headers: headers })).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) {
          document.dispatchEvent(new Ev.CartErrorEvent({ error: res.message || 'Add to cart failed', code: 'INVALID', detail: { description: res.description, errors: res.errors } }));
          deferred.reject(new Error(res.message || 'add failed'));
          return false;
        }
        return fetch(routes.cart_url + '.json', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          deferred.resolve({ cart: Ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: (host && host.tagName || 'lp').toLowerCase(), sourceId: (host && host.id) || 'lp', itemCount: qty || 1, productId: String(productId || ''), sections: res.sections, didError: false } });
          return true;
        });
      }).catch(function (err) { deferred.reject(err); throw err; });
    }).catch(function () {
      return fetch(routes.cart_add_url, { method: 'POST', body: fd }).then(function () { window.location.assign(routes.cart_url); return true; });
    });
  };
})();

/* ---- add-to-bag confirmation, shared ----
   The prototype bursts confetti in the collection's own palette out of the add button (atcPop/atcConfetti).
   The shelf had it, the product page did not (found 18 Sep 2026), so the single implementation lives here
   — both pages load lp-cart.js — rather than being copied into a second file. Reduced motion gets none. */
(function () {
  'use strict';
  if (window.lpConfetti) return;
  window.lpConfetti = function (btn, palette) {
    if (!btn) return;
    try { if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return; } catch (e) {}
    palette = (palette || []).filter(Boolean);
    if (!palette.length) palette = ['#a8875a', '#ecd9ac', '#6e2b26'];
    var r = btn.getBoundingClientRect();
    var layer = document.createElement('div');
    layer.className = 'confetti';
    layer.style.left = r.left + 'px'; layer.style.top = r.top + 'px';
    layer.style.width = r.width + 'px'; layer.style.height = r.height + 'px';
    document.body.appendChild(layer);
    var n = Math.min(34, Math.max(18, Math.round(r.width / 22))), longest = 0;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i');
      p.style.left = (6 + Math.random() * 88) + '%'; p.style.top = (30 + Math.random() * 40) + '%';
      var dir = Math.random() < 0.5 ? -1 : 1, x = dir * (20 + Math.random() * 150), peak = -(48 + Math.random() * 70),
          y = 90 + Math.random() * 130, rot = (Math.random() * 900 - 450), dur = 760 + Math.random() * 520;
      longest = Math.max(longest, dur);
      p.style.setProperty('--c', palette[i % palette.length]); p.style.setProperty('--x', x.toFixed(0) + 'px');
      p.style.setProperty('--peak', peak.toFixed(0) + 'px'); p.style.setProperty('--y', y.toFixed(0) + 'px');
      p.style.setProperty('--r', rot.toFixed(0) + 'deg'); p.style.setProperty('--d', dur.toFixed(0) + 'ms');
      p.style.animationDelay = (Math.random() * 90).toFixed(0) + 'ms';
      if (i % 3 === 0) { p.style.width = '9px'; p.style.height = '5px'; }
      else if (i % 3 === 1) { p.style.width = '6px'; p.style.height = '6px'; p.style.borderRadius = '50%'; }
      layer.appendChild(p);
    }
    setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, longest + 260);
  };
})();
